<template>
    <div>
      <el-row style="display: flex;margin-bottom: 10px;">
  
        <el-col>
          <el-button v-if="addUserVisitorBuildingClass" @click="$form('addUserVisitorBuildingClass')" size='small' type="primary"
            style="float:right" icon='el-icon-circle-plus'>添加楼宇分类
          </el-button>
        </el-col>
      </el-row>
      <div>
        <myform :viewobj='{
          addUserVisitorBuildingClass: ["新增楼宇分类", "el-icon-circle-plus"],
          updateUserVisitorBuildingClass: ["修改楼宇分类", "el-icon-edit-outline"],
          $succeed$: getUserVisitorBuildingClassList
        }' @confirm='myform' @close='$form("addUserVisitorBuildingClass", "reset")'>
        
  
          <hide slot='yuvbcId' />
        </myform>
        <mytable :tableColums='tableColums_getUserVisitorBuildingClassList' api='getUserVisitorBuildingClassList'
          xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
        </mytable>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        theProjectId: 0,
        value: '',
        form: {
          projectId: '',
  
        },
        tableColums_getUserVisitorBuildingClassList: {
          $selection: false,
  
          // oiType: '限制字段key',
  
          yuvbcName: '楼宇分类名称',
        //   yvqtcOrder: '排序',
         
  
          $operation: [
            '操作', 200,
            this.updateUserVisitorBuildingClass && `@text: 编辑#success
               @click: $form("updateUserVisitorBuildingClass",$this.row = $row)
              `,
            this.deleteUserVisitorBuildingClass && `@text: 删除#danger
               @click: _confirm('确定要删除该填写项吗?')
                       .trigger('deleteUserVisitorBuildingClass',{yuvbcId:$row.yuvbcId})
                       .trigger('getUserVisitorBuildingClassList')
              `,
          ],
        }
      }
    },
    methods: {
      myform(submit, Myformdata) {
         submit();
      },
  
    },
    created() {
      this.getUserVisitorBuildingClassList();
    },
  }
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/views/help/buildingType.vue